import api from 'plugin/api';

/**
 *  @description 검사결과 반송사유 등록 API(검사결과 공통)
 */

async function returnReasonCreate(seq, requestBody) {
  const url = `/sfsh/inspection/result/sendbk/${seq}`;

  const response = await api.post(url, requestBody);
  return response;
}

export { returnReasonCreate };
